import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import apiClient from '@helpers/apiClientHelper';

interface UseApiMutationOptions<TData = any>
  extends Omit<UseMutationOptions<TData, Error, any>, 'mutationFn'> {
  endpoint: string;
  headers?: Record<string, string>;
  method?: 'GET' | 'POST' | 'PUT';
}

const useApiMutation = <TData = any>(options: UseApiMutationOptions<TData>): UseMutationResult<TData, Error, any> => {
  const { endpoint, headers, method = 'POST', ...mutationOptions } = options;

  return useMutation<TData, Error, any>({
    ...mutationOptions,
    mutationFn: async (body: any): Promise<TData> => {
      try {
        let response;
        if (method === 'GET') {
          response = await apiClient.callGet(endpoint, headers, body ? { params: body } : undefined);
        } else if (method === 'PUT') {
          response = await apiClient.callPut(endpoint, body, headers);
        } else {
          response = await apiClient.callPost(endpoint, body, headers);
        }
        if (response.status == 200 && response.data.success) {
          return { success: true, message: response?.data?.message || 'Success', data: response.data?.result } as TData;
        } else {
          return { success: false, message: response?.data?.message || 'Request failed', data: {} } as TData;
        }
      } catch (error: any) {
        return { success: false, message: error?.message || 'Request failed', data: {} } as TData;
      }
    },
  });
};

export default useApiMutation;
